<p-dialog appDialogoPadrao="pi pi-users" descricao="Motivo usado ao afastar um funcionário." [visible]="visivel()" (visibleChange)="visivel.set($event)" [dismissableMask]="true" [header]="tituloModal" [style]="{ width: '460px', maxWidth: '95vw' }">
    <form [formGroup]="form" class="flex flex-col gap-4 pt-2">
        <div class="flex flex-col gap-1">
            <label for="ma-desc" class="text-sm font-semibold">Descrição <span class="text-red-500">*</span></label>
            <input id="ma-desc" pInputText type="text" formControlName="descricao" maxlength="50" placeholder="Ex.: Licença médica" (keyup.enter)="salvar()" />
            @if (form.controls.descricao.invalid && form.controls.descricao.touched) {
                <small class="text-red-500">Informe a descrição (até 50 caracteres).</small>
            }
        </div>
    </form>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" [text]="true" (onClick)="fechar()" />
        <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (onClick)="salvar()" [appCan]="roleMotivoEditar" />
    </ng-template>
</p-dialog>
